import React, { useState } from 'react';
import './NavBar.css';
import { refreshAllData } from '../utils/generateQuestionBanks';

function NavBar({ onBack, title = '学科知识库', onRefresh, onEdit }) {
  const [refreshing, setRefreshing] = useState(false);

  const handleGlobalRefresh = async () => {
    setRefreshing(true);
    try {
      await refreshAllData();
      
      // 如果有传入的刷新回调，调用它
      if (onRefresh) {
        await onRefresh();
      }
      
      // 显示成功提示
      console.log('✅ 全局数据已刷新');
      
      // 刷新当前页面以确保所有组件都获取最新数据
      window.location.reload();
    } catch (error) {
      console.error('❌ 全局刷新失败:', error);
    } finally {
      setRefreshing(false);
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-title">{title}</div>
      <div className="navbar-actions">
        {onEdit && (
          <button 
            className="navbar-edit-button" 
            onClick={onEdit}
            title="编辑题库"
          >
            ✏️ 编辑
          </button>
        )}
        <button 
          className="navbar-refresh-button" 
          onClick={handleGlobalRefresh}
          disabled={refreshing}
          title="刷新所有数据"
        >
          {refreshing ? '🔄' : '🔄'}
        </button>
        {onBack && (
          <button 
            className="navbar-button" 
            onClick={onBack}
          >
            返回
          </button>
        )}
      </div>
    </nav>
  );
}

export default NavBar;